import apiClient from './apiClient';

const almataApi = {
  addPartner: async (data) => {
    const formData = new FormData();
    
    Object.keys(data).forEach(key => {
      if (key === 'logo' && data[key]) {
        formData.append('logo', data[key]);
      } else if (key === 'stripeProductId' && Array.isArray(data[key])) {
        formData.append('stripeProductId', JSON.stringify(data[key]));
      } else if (key === 'planDetails' && Array.isArray(data[key])) {
        formData.append('planDetails', JSON.stringify(data[key]));
      } else if (key !== 'logo' && key !== 'refreshParams' && data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });

    const response = await apiClient.post('/partners/almata-partners', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  getPartners: async (params = {}) => {
    const { limit = 10, page = 1, search = '', status = '' } = params;
    const response = await apiClient.get('/partners/almata-partners', {
      params: { limit, page, search, status }
    });
    return response.data;
  },

  editPartner: async (data) => {
    const { id, ...editData } = data;
    const formData = new FormData();
    
    // Add id to the form data body
    formData.append('_id', id);
    
    Object.keys(editData).forEach(key => {
      if (key === 'logo' && editData[key]) {
        formData.append('logo', editData[key]);
      } else if (key === 'stripeProductId' && Array.isArray(editData[key])) {
        formData.append('stripeProductId', JSON.stringify(editData[key]));
      } else if (key === 'planDetails' && Array.isArray(editData[key])) {
        formData.append('planDetails', JSON.stringify(editData[key]));
      } else if (
        key !== 'logo' && 
        key !== 'refreshParams' && 
        key !== '_id' && 
        key !== 'createdBy' && 
        key !== 'updatedBy' && 
        key !== 'createdAt' && 
        key !== 'updatedAt' && 
        editData[key] !== null && 
        editData[key] !== undefined &&
        typeof editData[key] !== 'object'
      ) {
        formData.append(key, editData[key]);
      }
    });

    const response = await apiClient.put('/partners/almata-partners', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deletePartner: async (id) => {
    const response = await apiClient.delete('/partners/almata-partners', {
      data: { _id: id }
    });
    return response.data;
  },

  changeStatus: async (almataId, status) => {
    const response = await apiClient.patch('/partners/almata-partners/status', {
      almataId,
      status
    });
    return response.data;
  },

  getScanTypes: async () => {
    const response = await apiClient.get('/admin/scan-types');
    return response.data;
  },

  getOemPartners: async (params = {}) => {
    const { limit = 10, page = 1, search = '', status = 'active', createdBy } = params;
    const response = await apiClient.get('/partners/almata-partners/oem-partners/list', {
      params: { limit, page, search, status, createdBy }
    });
    return response.data;
  },

  getOemPartnerUsers: async (params = {}) => {
    const { oemId, page = 1, limit = 10, search = '' } = params;
    const response = await apiClient.get('/partners/almata-partners/oem-partners/user-list', {
      params: { oemId, page, limit, search }
    });
    return response.data;
  },

  resetPassword: async (data) => {
    const response = await apiClient.post('/partners/almata-partners/reset-password', {
      almataId: data.almataId,
      plainPassword: data.plainPassword
    });
    return response.data;
  },

  resendVerificationEmail: async (almataId) => {
    const response = await apiClient.post('/partners/almata-partners/resend-verification-email', {
      almataId
    });
    return response.data;
  }
};

export { almataApi };

// Legacy exports for backward compatibility
export const getAlmataPartnersApi = almataApi.getPartners;
export const addAlmataPartnerApi = almataApi.addPartner;
export const editAlmataPartnerApi = almataApi.editPartner;
export const deleteAlmataPartnerApi = almataApi.deletePartner;
export const changeAlmataStatusApi = almataApi.changeStatus;
export const getScanTypesApi = almataApi.getScanTypes;
export const getOemPartnersApi = almataApi.getOemPartners;
export const getOemPartnerUsersApi = almataApi.getOemPartnerUsers;
export const resetAlmataPasswordApi = almataApi.resetPassword;
export const resendAlmataVerificationEmailApi = almataApi.resendVerificationEmail;